import axios from 'axios';

export const clearAuth = () => {
  ['user', 'access_token', 'authenticated'].forEach(key => localStorage.removeItem(key));
  delete axios.defaults.headers.common.Authorization;
};

export const signin = async (formProps, callback) => {
  clearAuth();
  try {
    const response = await axios.post('auth/login', { email: formProps.email, password: formProps.password });
    const token = response.data.access_token;
    if (typeof token !== 'string' || !token) throw new Error('Invalid login response');
    axios.defaults.headers.common.Authorization = `Bearer ${token}`;
    const profile = await axios.get('auth/me');
    if (profile.data.admin !== 1 || profile.data.disabled || profile.data.deleted_at) throw new Error('Administrator access required');
    localStorage.setItem('access_token', token);
    localStorage.setItem('user', JSON.stringify(profile.data));
    localStorage.setItem('authenticated', 'true');
    callback();
  } catch (error) {
    clearAuth();
    throw error;
  }
};

export const signout = async () => {
  const token = localStorage.getItem('access_token');
  try {
    if (token) await axios.post('auth/logout', {}, { headers: { Authorization: `Bearer ${token}` } });
  } catch (error) {
    // The server may already have expired/revoked the session; always clear local state.
  } finally {
    clearAuth();
  }
};

export const auth = () => {
  let user = null;
  try { user = JSON.parse(localStorage.getItem('user')); } catch (error) { /* Invalid stored state is signed out. */ }
  const token = localStorage.getItem('access_token');
  return {
    user: JSON.stringify(user || {}),
    access_token: token,
    authenticated: localStorage.getItem('authenticated') === 'true' && !!token &&
      !!user && user.admin === 1 && !user.disabled && !user.deleted_at,
  };
};
